import { Typography, Button, Link } from "zudoku/components"
import { Badge } from "zudoku/ui/Badge"
import { ArrowRight } from "zudoku/icons"
import { Card, CardDescription, CardFooter, CardHeader, CardTitle } from "zudoku/ui/Card"

export const ThirdPartyApis = () => (
    <>
        <Typography className="my-5 max-w-none">
            <h1>Third Party APIs</h1>
            <p>
                Integrate with third-party financial infrastructure providers to extend your
                regulatory and payment capabilities.
            </p>
        </Typography>

        <Typography className="my-5 max-w-none">
            <h2>Overview</h2>
            <p>
                CBN's Third Party API integrations provide standardized access to Nigeria's core
                financial infrastructure. These APIs enable seamless connectivity with payment
                networks, clearing systems, and financial data providers essential for regulatory
                operations.
            </p>
        </Typography>

        <Typography className="mt-8 mb-4 max-w-none">
            <h2>Available Integrations</h2>
        </Typography>

        <div className="grid grid-cols-2 gap-4">
            <Card>
                <CardHeader>
                    <CardTitle>NIBSS APIs</CardTitle>
                    <CardDescription>
                        Nigeria Inter-Bank Settlement System APIs for payments, settlements,
                        identity verification, and Bank Verification Number (BVN) services.
                    </CardDescription>
                </CardHeader>
                <CardFooter>
                    <Button asChild variant="link" className="px-0">
                        <Link to="/products/third-party-apis/nibss">
                            Explore APIs <ArrowRight className="ml-1 h-4 w-4" />
                        </Link>
                    </Button>
                </CardFooter>
            </Card>

            <Card className="opacity-75">
                <CardHeader>
                    <div className="flex items-center justify-between mb-2">
                        <CardTitle>More Coming Soon</CardTitle>
                        <Badge variant="secondary" className="text-yellow-600 bg-yellow-100">Coming Soon</Badge>
                    </div>
                    <CardDescription>
                        Additional third-party integrations are being developed.
                        Stay tuned for updates.
                    </CardDescription>
                </CardHeader>
            </Card>
        </div>
    </>
)